module.exports = __webpack_public_path__ + "img/default.7ed8b49e.png";